import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './Style.scss';

const VerticalCellRenderer = ({ row, columns }) => {
  if (!columns || !row) return null;

  return (
    <div className="dt-vertical-renderer">
      {columns.map((col, index) => (
        <Row key={`${row.id || index}-${col.selector}`} className="data-row no-gutters">
          <Col xs={3} md={2} className="label-col arial-dt">
            {col.name}:
          </Col>
          <Col xs={9} md={10} className="value-col arial-dt">
            {row[col.selector] !== undefined && row[col.selector] !== null && row[col.selector] !== ''
              ? row[col.selector]
              : '-'}
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default VerticalCellRenderer;
